import { apiClient } from '../../app/api/client';

import type {
  ArchiveFilter,
  CsvImportResult,
  HoseGuidanceLibrary,
  HoseTypeInput,
  HoseTypePage,
  HoseTypeRead,
  PumpTemplateCreateInput,
  PumpTemplatePage,
  PumpTemplateRead,
} from './types';

export interface CatalogApi {
  archiveHose(id: string): Promise<HoseTypeRead>;
  archivePump(id: string): Promise<PumpTemplateRead>;
  createHose(payload: HoseTypeInput): Promise<HoseTypeRead>;
  createPump(payload: PumpTemplateCreateInput): Promise<PumpTemplateRead>;
  getPump(id: string): Promise<PumpTemplateRead>;
  getHoseGuidance(): Promise<HoseGuidanceLibrary>;
  importHoses(csvText: string, allowPartial: boolean): Promise<CsvImportResult>;
  listHoses(search: string, archived?: ArchiveFilter): Promise<HoseTypePage>;
  listPumps(search: string, archived?: ArchiveFilter): Promise<PumpTemplatePage>;
  restoreHose(id: string): Promise<HoseTypeRead>;
  restorePump(id: string): Promise<PumpTemplateRead>;
  revisePump(id: string, payload: PumpTemplateCreateInput): Promise<PumpTemplateRead>;
  updateHose(id: string, payload: HoseTypeInput): Promise<HoseTypeRead>;
}

function listPath(resource: string, search: string, archived: ArchiveFilter) {
  const query = new URLSearchParams({ archived, limit: '100', search });
  return `/catalog/${resource}?${query.toString()}`;
}

export const catalogApi: CatalogApi = {
  archiveHose: (id) => apiClient.post(`/catalog/hose-types/${id}/archive`),
  archivePump: (id) =>
    apiClient.post(`/catalog/pump-templates/${id}/archive`),
  createHose: (payload) =>
    apiClient.post('/catalog/hose-types', { json: payload }),
  createPump: (payload) =>
    apiClient.post('/catalog/pump-templates', { json: payload }),
  getPump: (id) => apiClient.get(`/catalog/pump-templates/${id}`),
  getHoseGuidance: () => apiClient.get('/catalog/hose-guidance'),
  importHoses: (csvText, allowPartial) =>
    apiClient.post('/catalog/hose-types/import', {
      json: { allow_partial: allowPartial, csv_text: csvText },
    }),
  listHoses: (search, archived = 'exclude') =>
    apiClient.get(listPath('hose-types', search, archived)),
  listPumps: (search, archived = 'exclude') =>
    apiClient.get(listPath('pump-templates', search, archived)),
  restoreHose: (id) => apiClient.post(`/catalog/hose-types/${id}/restore`),
  restorePump: (id) =>
    apiClient.post(`/catalog/pump-templates/${id}/restore`),
  revisePump: (id, payload) =>
    apiClient.put(`/catalog/pump-templates/${id}`, {
      json: { revision: payload.revision, template_name: payload.template_name },
    }),
  updateHose: (id, payload) =>
    apiClient.put(`/catalog/hose-types/${id}`, { json: payload }),
};
